import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

export const app = initializeApp(firebaseConfig);

// App Check (chống lạm dụng API) — chỉ kích hoạt khi đã đăng ký reCAPTCHA v3
// trong Firebase Console và đặt VITE_APPCHECK_SITE_KEY vào .env.
if (import.meta.env.VITE_APPCHECK_SITE_KEY) {
  import('firebase/app-check').then(({ initializeAppCheck, ReCaptchaV3Provider }) => {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(import.meta.env.VITE_APPCHECK_SITE_KEY),
      isTokenAutoRefreshEnabled: true
    });
  }).catch((e) => console.warn('App Check init failed:', e));
}

try { getAnalytics(app); } catch { /* analytics không khả dụng */ }

// Bộ nhớ đệm cục bộ (IndexedDB, nhiều tab dùng chung): mở lại trong ~30 phút gần như không tốn lượt đọc Firestore,
// và hiện dữ liệu ngay khi mạng chậm. Phải khởi tạo TRƯỚC mọi lời gọi getFirestore(); nếu trình duyệt không hỗ trợ
// (chế độ riêng tư…) thì quay về bộ nhớ tạm như cũ.
const createDb = () => {
  try {
    return initializeFirestore(app, { localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }) });
  } catch (e) {
    console.warn('Không bật được bộ nhớ đệm Firestore, dùng bộ nhớ tạm:', e);
    return getFirestore(app);
  }
};
export const db = createDb();
export const auth = getAuth(app);

// Hook chẩn đoán cho scripts/*.console.js (chạy trong DevTools của chính chủ
// tài khoản — mọi truy cập vẫn qua Firestore rules, không mở thêm quyền gì)
if (typeof window !== 'undefined') {
  import('firebase/firestore').then((firestoreModule) => {
    window.__fintrack = { app, db, auth, firestore: firestoreModule };
  });
}
